import type { SensorReading } from '@esf/shared';

// Generate time-series readings for the last 7 days
function generateReadings(
  deviceId: string, assetId: string, orgId: string,
  sensorType: SensorReading['sensorType'], unit: string,
  baseValue: number, variance: number, count = 50
): SensorReading[] {
  const now = Date.now();
  const interval = (7 * 24 * 60 * 60 * 1000) / count;
  return Array.from({ length: count }, (_, i) => ({
    id: `SR-${deviceId}-${String(i + 1).padStart(3, '0')}`,
    deviceId,
    assetId,
    organisationId: orgId,
    timestamp: new Date(now - (count - i) * interval).toISOString(),
    sensorType,
    value: Math.round((baseValue + (Math.random() - 0.5) * 2 * variance) * 10) / 10,
    unit,
  }));
}

export const demoSensorReadings: SensorReading[] = [
  // Solar monitor on SmartFlower (PROD-027) - power output in watts
  ...generateReadings('IOT-002', 'PROD-027', 'ORG-001', 'SOLAR_MONITOR', 'W', 280, 180),
  // Waste level on Broadmead bin (PROD-006) - fill percentage
  ...generateReadings('IOT-003', 'PROD-006', 'ORG-001', 'WASTE_LEVEL', '%', 55, 30),
  // Waste level on Cabot Circus recycling unit (PROD-007)
  ...generateReadings('IOT-004', 'PROD-007', 'ORG-001', 'WASTE_LEVEL', '%', 42, 25),
  // Air quality on Castle Park solar bench (PROD-028) - AQI index
  ...generateReadings('IOT-011', 'PROD-028', 'ORG-001', 'AIR_QUALITY', 'AQI', 38, 18),
  // Temperature at Harbourside totem (PROD-023)
  ...generateReadings('IOT-007', 'PROD-023', 'ORG-001', 'TEMPERATURE', 'C', 11.5, 4.5),
  // Light sensor on Castle Park pathway light (PROD-034)
  ...generateReadings('IOT-013', 'PROD-034', 'ORG-001', 'LIGHT_SENSOR', 'lux', 320, 250),
];
